<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 25" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <template v-else>
      <form-data :references.sync="formReferences" :model="modelObj" ref="offerReference">
        <template slot="extraDetails">
          <v-expansion-panels class="pa-3 pt-0 pb-0" v-if="modelObj.id">
            <attachments :model="modelObj" :module="SP_SALE_ORDER"></attachments>
          </v-expansion-panels>
          <order-material :orderModel="modelObj" ref="materials"></order-material>
        </template>
        <template slot="download_report">
          <v-btn color="info" class="ml-3" @click="createProductionOrder" v-if="modelObj.id" dark>
            {{ $t('message.order.newProdOrder') }}
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" class="ml-3" :loading="downloadLoading" v-if="modelObj.id" dark v-bind="attrs"  v-on="on">
                {{ $t('message.orders.packList') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item  v-for="(item, index) in downloadOptions" @click="downloadPackingOrder(item.value)" :key="index">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </form-data>
    </template>
    <v-dialog v-model="contactDialog" width="800" persistent>
      <form-data :references.sync="contactReference" :model="contactModel" ref="contactReference"></form-data>
    </v-dialog>
    <v-dialog v-model="addressDialog" width="800" persistent>
      <form-data :references.sync="addressReference" :model="addressModel" ref="addressReference"></form-data>
    </v-dialog>
    <!-- Offer accepted confirmation! -->
    <v-dialog v-model="offerCreation.dialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h3 class="mt-2">{{ $t('message.order.offerAccepted') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="offerCreation.loading" @click="createOrderFromOffer">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" @click="offerCreation.dialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Offer accepted confirmation! -->
    <v-dialog v-model="productionOrder.dialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.confirmation') }} </v-card-title>
        <v-card-text class="pa-5">
          <h3 class="mt-2">{{ $t('message.orders.sureToCreateOrder') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="productionOrder.loading" @click="productionOrder.onSuccess">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" @click="productionOrder.dialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import Customer from '@/mixins/Customer/index'
import PackingList from '@/mixins/Order/packing_list'
import CONSTANTS from '@/utils/order.json'
import axios from 'axios'
export default {
  data () {
    return {
      fieldsLoading: true,
      modelObj: {
        id: this.$route.params.order_id,
        contactid: 0,
        deliveryaddress: 0,
        paymentterms: 0,
        offerDatePicker: ''
      },
      loading: false,
      MODULE_URL: 'orders',
      contactsLoading: false,
      contactDialog: false,
      addressDialog: false,
      addressLoading: false,
      loadingProduct: false,
      contactModel: {},
      addressModel: {},
      listOfAddress: [],
      listOfContacts: [],
      listOfProducts: [],
      orderStatus: '',
      totalCalculation: {
        totalExVat: '0,00',
        total: '0,00'
      },
      canClear: false,
      reRender: 0,
      listOfHistories: [],
      customerPriorityId: 0,
      offerCreation: {
        dialog: false
      },
      downloadLoading: false,
      modelback: {},
      productionOrder: {
        dialog: false,
        loading: false
      }
    }
  },
  components: {
    'form-data': FormTemplate,
    'order-material': () => import('@/components/Order/Products'),
    attachments: () => import('@/components/Attachments')
  },
  mixins: [Customer, PackingList],
  computed: {
    ...mapState(['FORM_TYPE', 'listOfCustomers', 'listofCustomerShipments', 'listOfUsers']),
    downloadOptions () {
      return [
        {
          text: 'PDF',
          value: 'pdf'
        }, {
          text: 'XLSX',
          value: 'xlsx'
        }
      ]
    },
    formReferences () {
      return {
        title: this.$route.params.order_id ? '' : `${this.$t('message.common.add')} ${this.$t('message.layout.order')}`,
        properties: [{
          model: 'number',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          disabled: true,
          label: this.$t('message.product.number'),
          style: this.modelObj.id && this.modelObj.number ? 'display: block' : 'display: none',
          class: 'lg1 sm3',
          change: this.changesMade
        }, {
          model: 'customerid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfCustomers,
          term: 'customer',
          click: (term) => false,
          change: () => this.getCustomerRelatedData(),
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          rules: this.$_requiredValidation,
          class: 'lg3 sm9 xs12',
          label: this.$t('message.order.customer')
        }, {
          model: 'contactid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfContacts,
          term: '',
          click: (term) => this.addNewContact(term),
          is_list: true,
          loading: this.contactsLoading,
          select_text: 'name',
          select_value: 'id',
          class: 'lg3 sm6 xs12',
          label: this.$t('message.orders.contact'),
          change: this.changesMade
        }, {
          model: 'deliveryaddress',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfAddress,
          term: '',
          click: (term) => this.addNewAddress(term),
          is_list: true,
          select_text: this.getCombinedAddress,
          select_value: 'id',
          class: 'lg3 sm6 xs12',
          label: this.$t('message.orders.deliveryAddress'),
          change: this.changesMade
        }, {
          model: 'responsible',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfUsers,
          term: 'responsible',
          click: (term) => false,
          is_list: false,
          select_text: 'fullname',
          select_value: 'id',
          class: 'lg2 sm6 xs12',
          label: this.$t('message.deviations.responsible'),
          change: this.changesMade
        }, {
          model: 'ourreference',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          disabled: !this.modelObj.external_id || !!this.modelback.ourreference,
          label: this.$t('message.orders.ourReference'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'yourreference',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.orders.yourReference'),
          class: 'lg2 sm6',
          change: this.changesMade
        },
        // {
        //   model: 'paymentterms',
        //   type: this.FORM_TYPE.SELECT,
        //   rules: [],
        //   label: this.$t('message.order.paymentTerm'),
        //   items: this.paymentTerms,
        //   select_text: 'text',
        //   select_value: 'value',
        //   class: 'lg2 sm6',
        //   change: this.changesMade
        // },
        {
          model: 'state',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.tickets.status'),
          items: this.$_salesOrderStatus,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'shipment',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listofCustomerShipments,
          term: 'shipment',
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6 xs12',
          label: this.$t('message.customer.shipment'),
          change: this.changesMade
        },
        // {
        //   model: 'offerdate',
        //   rules: [],
        //   type: this.FORM_TYPE.DATEPICKER,
        //   class: 'lg2 sm6 xs12',
        //   picker: 'offerDatePicker',
        //   menu: 'dateMenu',
        //   color: 'primary lighten-1',
        //   label: this.$t('message.orders.offerDate'),
        //   change: this.changesMade
        // },
        // {
        //   model: 'offerduedate',
        //   type: this.FORM_TYPE.SELECT,
        //   rules: [],
        //   items: this.dueDates,
        //   select_text: 'text',
        //   select_value: 'value',
        //   class: 'lg2 sm6',
        //   label: this.$t('message.orders.offerDueDate'),
        //   change: this.changesMade
        // },
        {
          model: 'orderdate',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'orderDatePicker',
          menu: 'orderDateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.orders.orderDate'),
          change: this.changesMade
        }, {
          model: 'deliverydate',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'deliveryDatePicker',
          menu: 'deliveryDateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.orders.deliveryDate'),
          change: this.changesMade
        }, {
          model: 'attachments',
          type: this.FORM_TYPE.FILES,
          label: this.$t('message.product.attachments'),
          class: 'lg4 sm6 xs12',
          is_show: true
        }, {
          model: 'order_number',
          type: this.FORM_TYPE.LINK,
          to: `/orders/edit/${this.modelObj.source_ref}/view`,
          class: 'lg2 sm6 xs12'
        }, {
          model: '',
          type: this.FORM_TYPE.DIVIDER,
          rules: [],
          label: this.$t('message.orders.orderComments'),
          class: 'xs12 pa-1'
        }, {
          model: 'comments',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: '',
          class: 'xs12',
          rows: '3',
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.order_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'close_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.order_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          to: `/${this.MODULE_URL}`,
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          is_show: this.$route.params.order_id && this.$parent.canDeleteOrder
        }]
        // end_buttons: [{
        //   name: 'download',
        //   color: 'teal',
        //   // eslint-disable-next-line
        //   click: this.downloadOrder,
        //   loading: this.$parent.listPayloadObj ? this.$parent.listPayloadObj.loading : false,
        //   label: this.$t('message.order.download'),
        //   to: `/${this.MODULE_URL}`,
        //   class: 'text-right',
        //   is_show: this.$route.params.order_id
        // }, {
        //   name: 'share',
        //   color: 'info',
        //   label: this.$t('message.order.share'),
        //   click: this.shareOrder,
        //   class: 'text-right',
        //   is_show: this.$route.params.order_id
        // }]
      }
    },
    dueDates () {
      return [
        { text: `15 ${this.$t('message.common.days')}`, value: 15 },
        { text: `30 ${this.$t('message.common.days')}`, value: 30 }
      ]
    }
  },
  watch: {
    'modelObj.offerDatePicker' (val) {
      if (val) {
        this.modelObj.offerdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'modelObj.orderDatePicker' (val) {
      if (val) {
        this.modelObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'modelObj.deliveryDatePicker' (val) {
      if (val) {
        this.modelObj.deliverydate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  mounted () {
    this.$store.dispatch('getUsers')
    if (!this.modelObj.id) {
      this.$store.dispatch('getCustomersList')
      this.modelObj.offerduedate = 30
      this.modelObj.state = this.module === CONSTANTS.OFFER ? CONSTANTS.NEW : CONSTANTS.FOR_PRODUCTION
      this.modelObj.responsible = this.$store.state.userDetails ? this.$store.state.userDetails.id : ''
      this.modelObj.ourreference = this.$store.state.userDetails ? this.$store.state.userDetails.id : ''
      this.modelObj.offerdate = this.$_getCurrentDate()
    } else {
      this.$store.dispatch('getCustomersList')
        .then(() => {
          this.getSingleRecordHandler()
        })
    }
    this.$store.dispatch('getCustomerShipment')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'shipment', list: this.listofCustomerShipments })
        }
      })

    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push(`/${this.MODULE_URL}`)
      }
    })
    this.$root.$on('get_salesorder_details', () => {
      this.$root.$emit('reload_docs')
      this.getSingleRecordHandler()
    })
  },
  methods: {
    getCustomerRelatedData () {
      this.changesMade()
      this.modelObj.invoiceto = this.modelObj.customerid
      const getCustomerObj = this.listOfCustomers.find(x => x.id === this.modelObj.customerid)
      this.customerPriorityId = getCustomerObj ? getCustomerObj.priority : 0
      this.getPaymentTerm(this.modelObj.invoiceto || 0)
      this.getContacts(0)
    },
    setDefaultValues (data) {
      const { list, prop } = data
      const item = list.find(x => x.isdefault)
      if (item) {
        const model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        this.modelObj = model
      }
    },
    getAddresses (id) {
      if (this.modelObj.customerid) {
        this.addressLoading = true
        const query = { filter: `customer_id eq ${this.modelObj.customerid}` }
        this.$_executeApi('post', 'customeraddresses/query', query)
          .then((response) => {
            const address = response.data
            if (!this.modelObj.id || this.canClear) this.modelObj.deliveryaddress = 0
            if (!this.modelObj.id && address && address.length === 1) this.modelObj.deliveryaddress = address[0].id
            this.listOfAddress = response.data
            if (this.modelObj.id) this.canClear = true
            if (id) this.modelObj.deliveryaddress = id
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else {
        this.listOfAddress = []
        this.modelObj.deliveryaddress = 0
      }
    },
    getContacts (id) {
      if (this.modelObj.customerid) {
        this.contactsLoading = true
        const query = { filter: `customer_id eq ${this.modelObj.customerid}` }
        this.$_executeApi('post', 'contacts/query', query)
          .then((response) => {
            const list = response.data
            list.map((x) => {
              x.name = `${x.firstname || ''} ${x.lastname || ''}`
              return x
            })
            if (!this.modelObj.id || this.canClear) this.modelObj.contactid = 0
            this.listOfContacts = list
            if (id) this.modelObj.contactid = id
            this.getAddresses(0)
          })
          .finally(() => {
            this.contactsLoading = false
          })
      } else {
        this.listOfContacts = []
        this.modelObj.contactid = 0
      }
    },
    getSingleRecordHandler () {
      const query = {
        expand: [{
          select: ['number'],
          model: 'Order',
          on_field: 'id',
          on_parent_field: 'source_ref'
        }],
        filter: `id eq ${this.modelObj.id || 0}`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((result) => {
          const transformData = {
            date: { list: ['orderdate', 'offerdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
            number: { list: ['totalsum', 'totalexvat'], format: 'replaceDotWithComma' }
          }
          result.data = result.data[0] || {}
          const model = this.$_formatModel(result.data, transformData)
          model.offerduedate = +model.offerduedate
          this.module = model.type
          if (result.data) {
            this.modelback = this.$formatter.cloneVariable(model)
            this.modelObj = model
            this.orderStatus = model.state
            this.canClear = false
            const getCustomerObj = this.listOfCustomers.find(x => x.id === this.modelObj.customerid)
            this.customerPriorityId = getCustomerObj ? getCustomerObj.priority : 0
          }
          this.getContacts(0)
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    getOrderDetailedView () {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `orders/get_detail_view/${this.modelObj.id}`)
          .then((result) => {
            const transformData = {
              date: { list: ['orderdate', 'offerdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
              number: { list: ['totalsum', 'totalexvat', 'totalvat', 'dg'], format: 'replaceDotWithComma' }
            }
            const model = this.$_formatModel(result.data, transformData)
            resolve(model)
          })
          .catch((ex) => {
            reject(ex)
          })
      })
    },
    getSupplierByProduct (productId) {
      return new Promise((resolve, reject) => {
        const model = {
          expand: [{
            select: ['name'],
            model: 'Customer',
            on_field: 'id',
            on_parent_field: 'supplierid'
          }],
          filter: `productid eq '${productId}'`
        }
        this.$_executeApi('post', 'productsuppliers/query', model)
          .then((response) => {
            if (response.data) resolve(response.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    saveUpdateHandler (type) {
      if (this.$refs.offerReference.$refs.validateForm.validate()) {
        this.loading = true
        const url = this.MODULE_URL
        const transformData = {
          date: { list: ['orderdate', 'offerdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' },
          number: { list: ['totalsum', 'totalexvat'], format: 'replaceCommaWithDot' }
        }
        const model = this.$_formatModel(this.modelObj, transformData)
        model.type = this.module || ''
        this.$_saveUpdateHandler(url, model)
          .then((response) => {
            this.$store.commit('isChangesMade', false)
            this.$refs.materials.saveMaterials(false)
              .then(() => {
                this.loading = false
                this.navigatingHandler(type, model, response)
              })
              .catch(() => {
                this.loading = false
              })
          })
          .catch(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    approveMaterials () {
      // this.$refs.materials.approveMaterials()
    },
    navigatingHandler (type, model, response) {
      if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/edit/${response.id}/view`)
      else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
    },
    deleteHandler () {
      const ids = [this.modelObj.id]
      const payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    getPaymentTerm (id) {
      if (this.listOfCustomers && this.listOfCustomers.length > 0) {
        const customer = this.listOfCustomers.find(x => x.id === id)
        if (customer) {
          this.modelObj.paymentterms = customer.paymentterm || 0
        } else this.modelObj.paymentterms = 0
      }
    },
    addNewContact (term) {
      this.contactDialog = true
      this.contactModel = { isactive: true }
    },
    closeAddNewContact () {
      this.contactDialog = false
      this.contactModel.id = undefined
      this.$refs.contactReference.$refs.validateForm.reset()
    },
    addNewAddress () {
      this.addressDialog = true
      this.addressModel = { isstandard: true }
    },
    closeAddNewAddress () {
      this.addressDialog = false
      this.addressLoading = false
      this.addressModel.id = undefined
      this.$refs.addressReference.$refs.validateForm.reset()
    },
    saveUpdateContactHandler () {
      if (this.$refs.contactReference.$refs.validateForm.validate()) {
        this.contactLoading = true
        const model = this.contactModel
        model.customer_id = this.modelObj.customerid
        this.$_saveUpdateHandler('contacts', model)
          .then((response) => {
            this.contactDialog = false
            this.contactModel.id = undefined
            this.$refs.contactReference.$refs.validateForm.reset()
            this.getContacts(response.id)
          })
          .finally(() => {
            this.contactLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveUpdateAddressHandler () {
      if (this.$refs.addressReference.$refs.validateForm.validate()) {
        this.addressLoading = true
        const model = this.addressModel
        model.customer_id = this.modelObj.customerid
        model.type = model.type ? typeof model.type !== 'string' ? JSON.stringify(model.type) : model.type : ''
        this.$_saveUpdateHandler('customeraddresses', model)
          .then((response) => {
            this.addressModel.id = undefined
            this.$refs.addressReference.$refs.validateForm.reset()
            this.getAddresses(response.id)
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    createOrderFromOffer () {
      this.offerCreation.loading = true
      this.$_executeApi('post', `orders/create_order_from_offer/${this.modelObj.id}`)
        .then((response) => {
          this.$store.commit('isChangesMade', false)
          this.offerCreation.dialog = false
          if (this.offerCreation.type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
        })
        .finally(() => {
          this.offerCreation.loading = false
        })
    },
    downloadPackingOrder (type) {
      if (type === 'pdf') this.pdfPackingOrder()
      else if (type === 'xlsx') this.excelPackingOrder()
    },
    pdfPackingOrder () {
      this.downloadLoading = true
      this.$eventBus.$emit('downloadLoading', true)
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', 'orders/generate_packing_report', { visiblefilename: `Pakkseddel_${this.modelObj.number}`, content: await this.genereatePackReportContent(reportData) })
          .then((response) => {
            const fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.downloadLoading = false
          })
      })
    },
    excelPackingOrder () {
      this.downloadLoading = true
      this.$eventBus.$emit('downloadLoading', true)
      this.$_executeApi('post', `orders/export_packing_report/${this.modelObj.id}`)
        .then((response) => {
          const fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.downloadLoading = false
        })
    },
    createProductionOrder () {
      this.productionOrder = {
        dialog: true,
        onSuccess: () => {
          this.productionOrder.loading = true
          this.$_executeApi('post', `orders/create_productionorder_from_sales?orderId=${this.modelObj.id}`)
            .then((response) => {
              if (response && response.data) {
                this.$router.push(`/production_order/order/actions/${response.data}`)
              }
            })
            .finally(() => {
              this.productionOrder.loading = false
            })
        }
      }
    },
    getCombinedAddress (obj) {
      const addressItems = (({ address, address2, postcode, city }) => ({ address, address2, postcode, city }))(obj)
      return this.getCommaStringFromObj(addressItems)
    },
    getCommaStringFromObj (obj) {
      Object.keys(obj).forEach(key => !obj[key] && delete obj[key])
      return Object.values(obj).join(', ')
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$root.$off('get_salesorder_details')
  }
}
</script>
